function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-119.3,373.5l-66.1-31.8l47,51.7l-43,22.3l43.8,7.2l-8.8,54.1l40.6-41.4l38.2,38.2l-8-51.7l43-7.2l-38.2-23.1l27.1-38.2 l-45.4,11.9l-17.5-48.6L-119.3,373.5z M-128.1,438.8l4.8-27.1l-22.3-3.2l24.7-13.5l-19.1-20.7l27.9,13.5l7.2-29.5l8,21.5l23.9-6.4 L-88.3,395l21.5,12.7l-23.1,4l4,26.3l-20.7-19.9L-128.1,438.8z"
});

var SvgSwrpgSuccess = function SvgSwrpgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-success.a1dab52b.svg";
export { ForwardRef as ReactComponent };